import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Theme1Routes from "./Theme1Routes";
import Theme2Routes from "./Theme2Routes";
import { SendPostRequest } from "./http";
import { setLogindata1, setProfileCheck } from "./store/global/actions";
import { Modal, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Circles } from "react-loader-spinner";

function App() {
  const [data, setData] = useState({});
  const [isData, setIsdata] = useState(false);
  const sitedata = useSelector((store) => store.global.loginData);

  const [openAd, setOpenAd] = useState(false);
  const dispatch = useDispatch();
  const patientLogin = useSelector((state) => state.patient.patientLogin);

  const [loginCheck, setLoginCheck] = useState({});
  const [appLoading, setAppLoading] = useState(true); // ✅ Loader for first render

  // useEffect(() => {
  //   getData();
  //   loginCheckData();
  // }, []);

  // const getData = async () => {
  //   try {
  //     const res = await SendPostRequest("branding/info");
  //     setData(res?.data);

  //     if (res?.data) {
  //       localStorage?.setItem("login_type", res?.data?.site_type);
  //       dispatch(setLogindata1(res.data));
  //     }

  //     const promo = res?.data?.promotions;
  //     // ✅ Show only first time in current tab
  //     const alreadyClosed = sessionStorage.getItem("adClosed");

  //     if (
  //       promo?.image &&
  //       isPromoValid(promo.start_date, promo.expiry_date) &&
  //       !alreadyClosed
  //     ) {
  //       setOpenAd(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching branding info", error);
  //   }
  // };

  useEffect(() => {
    // ✅ fetch branding + profile check
    getData().finally(() => setAppLoading(false));
    loginCheckData();
  }, []);

  // const getData = async () => {
  //   try {
  //     const res = await SendPostRequest("branding/info");
  //     setData(res?.data);

  //     if (res?.data) {
  //       localStorage?.setItem("login_type", res?.data?.site_type);
  //       dispatch(setLogindata1(res.data));
  //     }

  //     const promo = res?.data?.promotions;
  //     const alreadyClosed = sessionStorage.getItem("adClosed");

  //     if (
  //       promo?.image &&
  //       isPromoValid(promo.start_date, promo.expiry_date) &&
  //       !alreadyClosed
  //     ) {
  //       // ✅ Show ad after 8 seconds
  //       setTimeout(() => {
  //         setOpenAd(true);
  //       }, 8000);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching branding info", error);
  //   }
  // };

  const getData = async () => {
    try {
      const res = await SendPostRequest("branding/info");
      setData(res?.data);

      if (res?.data) {
        localStorage?.setItem("login_type", res?.data?.site_type);
        dispatch(setLogindata1(res.data));
      }

      const promo = res?.data?.promotions;
      const alreadyClosed = sessionStorage.getItem("adClosed");
      const alreadyShown = sessionStorage.getItem("adShown");
      if (
        promo?.image &&
        isPromoValid(promo.start_date, promo.expiry_date) &&
        !alreadyClosed &&
        !alreadyShown
      ) {
        sessionStorage.setItem("adShown", "true");
        setTimeout(() => {
          setOpenAd(true);
        }, 8000);
      }
    } catch (error) {
      console.error("Error fetching branding info", error);
    }
  };


  const isPromoValid = (start, end) => {
    const now = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);
    return now >= startDate && now <= endDate;
  };

  const loginCheckData = async () => {
    try {
      const res = await SendPostRequest("home/profile_check", {
        theme: sitedata?.options?.theme,
      });
      if (res?.data && Array.isArray(res?.data) && res?.data?.length > 0) {
        setLoginCheck(res?.data[0]);
        dispatch(setProfileCheck(res?.data[0]));
      } else {
        console.warn("No Record Available or invalid format");
      }
    } catch (error) {
      console.error("Error fetching profile check data", error);
    }
  };

  const promo = sitedata?.promotions;

  const handleCloseAd = () => {
    setOpenAd(false);
    sessionStorage.setItem("adClosed", "true"); // Remember user closed it
  };


  // ✅ Show loader until branding/info API resolves
  if (appLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        <Circles
          height="80"
          width="80"
          color="#000"
          ariaLabel="circles-loading"
          visible={true}
        />
      </div>
    );
  }

  return (
    <BrowserRouter>
      {/* Advertisement Modal */}
      <Modal open={openAd} onClose={handleCloseAd}>
        <div className="promo-modal">

          {/* ✅ Close button on image */}
          <IconButton
            onClick={handleCloseAd}
            sx={{
              position: "absolute",
              top: "15px",
              right: "15px",
            }}
            className="newslatterpopup-close-btn"
          >
            <CloseIcon sx={{ color: "#fff" }} />
          </IconButton>

          {/* Body */}
          <div>
            <img
              src={promo?.image}
              alt="Promotion Banner"
              style={{
                width: "100%",
                height: "auto",
                // maxHeight: "70vh",
                display: "block",

              }}
            />
          </div>

          {/* Footer */}
          {promo?.button_link ? (
            <div
              style={{
                position: "sticky",
                bottom: 0,
                background: "#fff",
                padding: "15px",
                borderTop: "1px solid #ddd",
              }}
            // style={{
            //   padding: "15px 30px",
            //   borderTop: "1px solid #ddd",
            //   textAlign: "end",
            //   background: "#f5f5f5",
            // }}
            >
              {/* <Button
              variant="contained"
              color="primary"
              className="btn btn-default"
              style={{ width: "100%", fontWeight: "600", padding: "12px 0px" }}
              onClick={() => {
                window.open(promo?.button_link || "#", "_blank");
                handleCloseAd();
              }}
            >
              {promo?.button_title || "Learn More"}
            </Button> */}
              <Button
                variant="contained"
                color="primary"
                className="btn btn-default"
                style={{ width: "100%", fontWeight: "600", padding: "12px 0px" }}
                onClick={() => {
                  sessionStorage.setItem("adClosed", "true");
                  window.open(promo?.button_link || "#", "_blank");
                  handleCloseAd();
                }}
              >
                {promo?.button_title || "Learn More"}
              </Button>

            </div>
          ) : null}

        </div>
      </Modal>

      {/* Routes */}
      {sitedata?.options?.theme === "mist" ? (
        <Theme2Routes
          isData={isData}
          setIsdata={setIsdata}
          patientLogin={patientLogin}
        />
      ) : (
        <Theme1Routes
          isData={isData}
          setIsdata={setIsdata}
          patientLogin={patientLogin}
        />
      )}
    </BrowserRouter>
  );
}

export default App;
